var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperaGlasses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_475_39018)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1369,
    transform: "translate(-1245 -286)",
    fill: "#E37617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1165 -286H195V1083H-1165V-286Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_475_39018)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1130,
    y: -158,
    width: 1297,
    height: 1177,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1111.5,
    y: -20.5,
    width: 1261,
    height: 111,
    fill: "white",
    stroke: "#DADADA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_475_39018",
    x: -1142,
    y: -162,
    width: 1323,
    height: 1201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_39018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_39018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_475_39018",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_475_39018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1369,
    fill: "white",
    transform: "translate(-1245 -286)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_475_39018",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEx0lEQVR4nO1ZbWiWVRi+nB/DD4wgS+dMzQJh0z/+8AuaLtdKbVDUDwtE6U8jQf8oZtimgt+rfmRbQlCiaYE404Lmmik4tY9FUApiFDgr16awtjlne1+55Tpy8+w8H+fs8UfxXnDgfc79cZ3nOfe5z33OC+SQQw45/N/xHICTALrYmgCUDMLfAvrQ/pbgPmMrgGxIeyOgOwXAQQBtbJ8AmBzQ2RDhb8v9eokKEtwGsBbAQwDGAVjHvgyAxdSdBOCqZXCtAAqps5Q2Yf6yyl+qOEnnQhTEesq+4XMdnw8BeATAeACfsa+WOqcS+Ps67ZcoA9ATEQZhTb6ywcMe9j3kTgU1HgOQ1mnx1eXpa9dgX+J1OuoD8KaK7yjMoM1Fi+wSZaITh0IAG9V6qYQnRgL4m05ecbB7hjaNEetMdJJiBW0k842CB16mg+8d7V6l3T6LbD9lopMUQwD8QLvl8ECj55RW0U72nCB2UvaWo8/XaCeZzgmycfUDuAngQUfbvSRdZZGtpuwDR58PAOim7XQXw2oaSSi44gvavmCRvUjZcQ+/+2i7zSUmf6XRUx6EP9J2tkU2j7IWD78ltP0LwPAkBoto8BuAPA/CNtpLmWILWZFdgx8u0l7KpVgcoLIsWleMYP3UH/LVhlMmOvke/tdzbEeTLiohesyDaAqJ/ozQuUadYCWcBOO5OcsmWRClWEmSBvhhPu0l74ehhTqyXnxwlPYyO6E4T6VlAIoAbAdwFkA7Z6kDwDn2F1vsX6L9sQiO49QR3SBmANhBjuvklOqimZxF6jhxiYlpAIqp0M+BZGIKOZEfDtRfayjby1Qrfi6zHWOf2WdE12ASfWUSFJAyI7f4uyRJldsL4CMApTzwDGVcSln9vtqgOqgDVqlZRSTtX7ZsQGYq2lJ+femT6ngPM2cBk4eN07SPbdnELEJpJwBMQDSE4Aj1pQJYyOOs8XGefflsMuBvlVx0Z6nSXmbEhTPLF5MEdQ/PK+F7/PpJIDH6Nu0kli/wtwx4tEVf+r6jzi/qOLw7LN5jOLOsw+7hS3Y2ObyEdlwfmHIJjTCUBXQPO7yEjVNm/i5mcpH9E5ebIzAxEL9jI3THKr2uBOEUxyljnwamO3H6IQaHWpXNxkTojVHZaU9KnFV673h6kE7L1Zd+NkJvsdIrS4nztDzc4MOjFFaElOBJptoM8GcelYMYSZnRK0iJ83ewdsmqIq6Tud510ecHFvFPvA7NY1vAPq0zIiXOXqgUaL6OeX7c8+u0s8Qwg+1THyurSp40OVtBxzpezaa22TNeG7jBrgTwFUla+VtuRIZxw02Ts1kfa6UEEMxlVul1vGWvczjHbEqZs9oUixnmZDPV76rYk1vxJ2Lit5DXm1JwTk0wgGkpcmZ0JX6ITo5w1xxKx7oavRnyv0WeOiNIiCRFWpwHgye7DgpqVMkwhzcpV7jzL7E4fEdVwXKCS4oClfp9OdttJ81SlV3qmREQM7Wfqy/3JNxRQlsfzj51fBiAUjUz3SwBygNng3IuMvM3Q1tMkRiHReqOuTshZ3vUSxhMZvzGndb6qWe79nGFVBWf0mcUZ4ZrwuniophprZkbluy8fwA4w345P6eNIqbmZnLdIrfhtN0T5JBDDjngv4c79oArZC9soEsAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperaGlasses);
export default __webpack_public_path__ + "static/media/OperaGlasses.c609edf3128a6c64c2888aadbffb229c.svg";
export { ForwardRef as ReactComponent };